import { Component, OnInit, OnDestroy } from '@angular/core';
import { SwUpdateService } from '../../services/sw-update.service';
import { interval, Observable, of, Subscription } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

@Component({
  selector: 'app-update-notification',
  template: `
    <div *ngIf="showUpdateNotification" class="update-notification">
      <div class="update-content">
        <div class="update-icon">
          <i class="fa fa-download" aria-hidden="true"></i>
        </div>
        <div class="update-text">
          <h4>Update Available</h4>
          <p>A new version of the application is now available. The page will reload automatically in {{timer$ | async}} seconds.</p>
        </div>
      </div>
      <div class="update-content" style="justify-content: flex-end;">
        <div class="update-actions">
          <button class="btn btn-primary btn-sm" (click)="updateNow()">
            Update Now
          </button>
          <button class="btn btn-secondary btn-sm" *ngIf="false" (click)="dismiss()">
            Dismiss
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .update-notification {
      position: fixed;
      top: 20px;
      right: 20px;
      background: #fff;
      border: 1px solid #ddd;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      z-index: 9999;
      max-width: 400px;
      animation: slideIn 0.3s ease-out;
    }

    .update-content {
      display: flex;
      align-items: center;
      padding: 16px;
      gap: 12px;
    }

    .update-icon {
      color: #007bff;
      font-size: 24px;
      flex-shrink: 0;
    }

    .update-text {
      flex: 1;
    }

    .update-text h4 {
      margin: 0 0 4px 0;
      font-size: 16px;
      font-weight: 600;
      color: #333;
    }

    .update-text p {
      margin: 0;
      font-size: 14px;
      color: #666;
      line-height: 1.4;
    }

    .update-actions {
      display: flex;
      gap: 8px;
      flex-shrink: 0;
    }

    .btn {
      padding: 6px 12px;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
      font-weight: 500;
      transition: all 0.2s ease;
    }

    .btn-primary {
      background: #007bff;
      color: white;
    }

    .btn-primary:hover {
      background: #0056b3;
    }

    .btn-secondary {
      background: #6c757d;
      color: white;
    }

    .btn-secondary:hover {
      background: #545b62;
    }

    @keyframes slideIn {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }

    @media (max-width: 768px) {
      .update-notification {
        top: 10px;
        right: 10px;
        left: 10px;
        max-width: none;
      }
      
      .update-content {
        flex-direction: column;
        text-align: center;
      }
      
      .update-actions {
        width: 100%;
        justify-content: center;
      }
    }
  `]
})
export class UpdateNotificationComponent implements OnInit, OnDestroy {
  showUpdateNotification = false;
  private subscription: Subscription = new Subscription();
  timer$: Observable<number> = of(15);
  
  constructor(private swUpdateService: SwUpdateService) {}

  ngOnInit(): void {
    console.log('UpdateNotificationComponent ngOnInit');
    // Listen for update availability
    this.subscription.add(
      this.swUpdateService.updateAvailable$.subscribe(updateAvailable => {
        console.log('updateAvailable', updateAvailable);
        if (updateAvailable) {
          this.showUpdateNotification = true;
          this.timer$ = interval(1000).pipe(
            take(16),
            map(i => 15 - i),
            tap(value => {
              if (value === 0) {
                this.updateNow();
              }
            })
          );
        } 
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  updateNow(): void {
    this.swUpdateService.activateUpdate();
  }

  dismiss(): void {
    this.showUpdateNotification = false;
  }
}

